
export default function Topbar() {
    //mega menu on hover
    var menu_time = 250;
    var menu_fade_timer;

    $('ul.nav-binnacle > .parent').mouseenter(function() {
      // return
      clearTimeout(menu_fade_timer);
      HideCurrentMenu(menu_time);
      $('#header .hero .overlay').stop().show().animate({opacity: 0.6}, menu_time);
      $('#header .hero .hero-text').stop().show().animate({opacity: 0}, menu_time);

      //add description, set left indent
      var window_width = $(window).width();
      var left_offset = $('.nav-binnacle li').first().position().left + 15;
      if (window_width < 850) { left_offset = 27; }
      var menu_title = $(this).children('a').find('span').text();
      var description = $(this).attr('description');
      $(this).find('ul .description').remove();
      $('<li class="description" style="left: '+left_offset+'px;"><h2>'+menu_title+'</h2><p>'+description+'</p></li>').prependTo($(this).children('ul'));
      var description_width = $(this).find('ul .description').width();
      var left_item_offset = left_offset + description_width + 40;


      $(this).children('ul').children('li, .half1').not('.description').css('margin-left', left_item_offset);



      $(this).children('ul').stop().show().animate({opacity: 1}, menu_time);
      $(this).children('ul').css('top', $('.main-navbar').outerHeight());	//fix top position of menu

      var description_height = $(this).find('ul .description').height();

      if (description_height > $(this).children('ul').height()) {
        $(this).children('ul').height(description_height);
      }

    });

    $('ul.nav-binnacle > .parent').mouseleave(function() {
      menu_fade_timer = setTimeout(function() {
        HideCurrentMenu(menu_time);
      }, 700);
    });

    //hide current menu
    function HideCurrentMenu(menu_time) {
      $('#header .hero .overlay').stop().animate({opacity: 0}, menu_time, function() {
        $(this).hide();
      });
      $('#header .hero .hero-text').stop().show().animate({opacity: 1}, menu_time);
      $('.nav-binnacle > .parent ul:visible').stop().animate({opacity: 0}, menu_time, function() {
        $(this).hide();
      });
    }



    $('.nav-binnacle > li > .subnav > li > a').on('mouseenter', show_right_submenu_delayed);


    //group sport specialty programs here
    //this is a temporary solution until backend is changed

    var group = {};
    var programs = $('a:contains("Sport Specialty Programs")').parent().children('.subnav');
    programs.find('span').each(function () {
      var title, m = /(^.+) - (nrl|rugby|netball)$/i.exec(this.innerHTML);
      if (m) {
        if (!group[title = m.pop()]) {
          group[title] = [];
        }
        group[title].push($(this).closest('li'));
        this.innerHTML = m.pop();
      }
    });

    var li, submenu, a;
    for (var title in group){
      li = document.createElement('li');
      li.appendChild(a = document.createElement('a'));
      li.appendChild(submenu = document.createElement('ul'));
      a.innerHTML = title;
      a.className = 'purple';

      var i = group[title].length;
      while (i--){
        submenu.appendChild(group[title][i][0]);
      }

      programs.append(li);
    }
}


var right_submenu, right_submenu_timer;
function show_right_submenu_delayed(){

  var a = $(this);
  var submenu = a.next();



  $('.subnav .current').removeClass('current');
  a.parent().addClass('current');

  //change height here
  var large_subnav = a.closest('.subnav');
  var current = large_subnav.height();

  var subnav_items_height = 0;
  a.closest('.subnav').children('li:not(.description)').each(function () {
    subnav_items_height += $(this).height();
  });

  large_subnav.height(current);
  large_subnav.height(Math.max(
    large_subnav.find('.description').height(),
    submenu.height(),
    subnav_items_height
  ));


  var padding = 35;
  var offset = a.offset().top - large_subnav.offset().top - padding;
  submenu.css('top', -offset+'px');

  submenu.show();
  setTimeout(function () {
    submenu.addClass('visible');
  }, 10);

  if (right_submenu) {
    right_submenu.removeClass('visible').hide();
  }
  right_submenu = submenu;
}
